import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { tcDaviviendaText } from '@environment/tc-davivienda-text';
import * as moment from 'moment-timezone';
import { BehaviorSubject } from 'rxjs';
import { TcDaviviendaService } from '../service/tc-davivienda.service';
import { TcDaviviendaHome } from '../model/tc-davivienda';
declare const dataLayer: any;

const NO_TC: string = "NoExistingTC";
const INACTIVE_TC: string = "InactiveTC";
@Component({
  selector: 'app-tc-davivienda',
  templateUrl: './tc-davivienda.component.html',
  styleUrls: ['./tc-davivienda.component.scss'],
})
export class TcDaviviendaComponent implements OnInit {
  tipo_cedula = new FormControl('', [Validators.required]);
  title: string;
  subtitle: string;
  typesDocuments: any[] = tcDaviviendaText.tcDaviviendaTypesDocuments;
  typeFunction: string = 'firstConsult';
  homeTC: boolean = true;
  noTc: boolean = false;
  noActivated: boolean = false;
  textDavivienda: string = tcDaviviendaText.textDavivienda;
  actionTag: string;
  documentoNumber: any;
  tcDaviviendaHome: TcDaviviendaHome;
  public modalType = new BehaviorSubject<string>("");

  userDataItems: Array<string> = ['dataTempAddress', 'dataTempFormNoLogin', 'directionTemp', 'temporarySelectedCity', 'tempDataAddressFound', 'dataUpdateCart', 'dataCart', 'shoppingToken', 'userIDNoLogin', 'userInfo'];
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: Router,
    private tcDaviviendaService: TcDaviviendaService
  ) {
    route.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        if(event.url.includes("alianzas/davivienda")){
          const favIconLink = document.querySelector("link[rel~='icon']");
          favIconLink.setAttribute('href', 'faviconV2.ico');
        }
      }
    })
  }

  ngOnInit() {
    this.title = tcDaviviendaText.initialTcDavivienda.title;
    this.subtitle = tcDaviviendaText.initialTcDavivienda.subtitle;
    this.tcDaviviendaService.getHome().subscribe({
      next: response => {
        this.tcDaviviendaHome = response.result
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      this.removeUserData();
      if (localStorage.getItem('userSesionTC')) {
        let tcInfoUser = JSON.parse(localStorage.getItem('userSesionTC'));
        let userDate = moment(tcInfoUser.date).tz('America/Bogota').format();
        let currentDate;
        if (
          moment(userDate).month() + 1 <= moment().month() + 1 &&
          moment(userDate).date() === moment().date() &&
          moment(userDate).hours() < 10 &&
          moment(userDate).minute() < 58
        ) {
          currentDate = moment(userDate)
            .tz('America/Bogota')
            .set({ hour: 9, minute: 0, second: 0, millisecond: 0 })
            .format();
        } else {
          currentDate = moment()
            .tz('America/Bogota')
            .add(1, 'days')
            .set({ hour: 10, minute: 0, second: 0, millisecond: 0 })
            .format();
        }
        let duration = moment.duration(moment(currentDate).diff(userDate));
        let hours = duration.asHours();
        if (hours > 0 || hours < 24) {
          this.getValidateId(tcInfoUser.status);
        } else {
          localStorage.removeItem('userSesionTC');
          localStorage.removeItem('usedTC');
        }
      }
    }
  }

  getValidateId(event: string) {
    switch (event) {
      case 'ACTIVO':
        this.route.navigate(['/alianzas/davivienda/beneficios-tarjeta-credito/servicios']);
        this.actionTag ="JPW- ingresa tus datos"
        this.tagTarjetaCredito();
        break;
      case 'INACTIVO':
        this.noTc = false;
        this.homeTC = false;
        this.noActivated = true;
        this.title = tcDaviviendaText.inactiveTcDavivienda.title;
        this.subtitle = tcDaviviendaText.inactiveTcDavivienda.subtitle;
        localStorage.removeItem('userSesionTC');
        localStorage.removeItem('usedTC');
        this.actionTag ="JPW- reintentar ingreso de datos"
        this.tagTarjetaCredito();
        this.openModal(INACTIVE_TC);
        break;
      case 'noExistingTC':
        this.noTc = true;
        this.homeTC = false;
        this.noActivated = false;
        this.title = tcDaviviendaText.noTcDavivienda.title;
        this.subtitle = tcDaviviendaText.noTcDavivienda.subtitle;
        localStorage.removeItem('userSesionTC');
        localStorage.removeItem('usedTC');
        this.actionTag ="JPW- reintentar ingreso de datos"
        this.tagTarjetaCredito();
        this.openModal(NO_TC);
        break;
    }
    window.scrollTo(0, 0);
  }

  //39A
  tagTarjetaCredito(){
    dataLayer.push({'event':'ga_event',
                    'category':'tarjeta davivienda',
                    'action':this.actionTag,
                    'label':'Continuar',
                    'cc':btoa(this.documentoNumber)
                    })


  }

  getDocumento($event){
    this.documentoNumber = $event;
  }
  //39G
  tagInactiveCard() {
    dataLayer.push({
      'event':'ga_event',
      'category':'tarjeta davivienda',
      'action':'JPW- tarjeta inactiva',
      'label':'tarjeta de credito inactiva'
    })
  }
  /**
   * The `removeUserData` function removes specific items from the localStorage based on the items
   * stored in `userDataItems`.
   */
  removeUserData() {
    this.userDataItems.forEach(item => {
      if(localStorage.getItem(item)) {
        localStorage.removeItem(item);
      }
    })
  }
   /** The `openModal` function opens a modal of a specified type after a short delay.
   * @param {string} modal - The `openModal` function takes a `modal` parameter, which is a string
   * representing the type of modal to be opened.
   */
  openModal(modal: string){
    setTimeout(() => {
      this.modalType.next(modal);
      if(modal === INACTIVE_TC){
        this.tagInactiveCard();
      }
    }, 50);
  }
}
